import { SubZone } from '../../interfaces'
import { GET_SUBZONES_EXITO, GET_SUBZONES } from '../types/subzoneActionsTypes'

export type SubZoneAction = SubZonesAction | SubZonesActionAsync

// Esto va a REDUX
export interface SubZonesAction {
  type: typeof GET_SUBZONES_EXITO
  subzones: SubZone[] | undefined
  error: string | undefined
}

export const getSubZonesAction = (
  subzones?: SubZone[],
  error?: string
): SubZonesAction => {
  return {
    type: GET_SUBZONES_EXITO,
    subzones,
    error
  }
}

// Esto va a SAGA
export interface SubZonesActionAsync {
  type: typeof GET_SUBZONES
}

export const getSubZonesActionAsync = (): SubZonesActionAsync => {
  return {
    type: GET_SUBZONES
  }
}
